import { Mapper } from 'master-locations-library/master-locations-library/src/lib/core/base';
import {
  Job,
  Location,
  MasterPlan,
  Plan,
} from 'master-locations-library/master-locations-library/src/lib/core/domain/models/master-plan';
import { MasterPlanWebEntity } from './master-plan-web-entity';
import { PlanWebEntity } from './plan-web-entity';
import { JobWebEntity } from './job-web-entity';
import { LocationWebEntityForMasterPlan } from './location-web-entity';

export class MasterPlanWebEntityMapper extends Mapper<
  MasterPlanWebEntity,
  MasterPlan
> {
  mapFrom(param: MasterPlanWebEntity): MasterPlan {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distributionLaneName: param.distributionLaneName,
      distributionLaneId: param.distributionLaneId,
      planDays: param.planDays,
      committedPlansCount: param.committedPlansCount,
      jobs: []
    };
  }

  mapTo(param: MasterPlan): MasterPlanWebEntity {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      distributionLaneName: param.distributionLaneName,
      distributionLaneId: param.distributionLaneId,
      planDays: param.planDays,
      committedPlansCount: param.committedPlansCount,
    };
  }
}
